import React, { useEffect, useState } from "react";
import MainContainer from "../../common/MainContainer";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import Loader from "../../common/Loader";

const EditBlogCategory = (props) => {
  let history = useHistory();
  const { id } = props.match.params;
  const [isLoading, setIsLoading] = useState(true);
  // console.log("available props >> ", id)
  const basurl = process.env.REACT_APP_URL;
  const userToken = props.user.userToken;
  const { register, handleSubmit, errors, setValue } = useForm();

  // get category details
  const getCategoryDetails = () => {
    setIsLoading(true);
    axios
      .get(`${basurl}/blogs/categories/view/${id}`)
      .then((res) => {
        const result = res.data;
        if (result.success) {
          setValue("category", result.data.category);
        }
        setIsLoading(false);
        // console.log("get cat >> ", result);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  const onSubmit = (data, e) => {
    setIsLoading(true);
    axios
      .put(
        `${basurl}/blogs/categories/edit/${id}`,
        {
          category: data.category,
        },
        {
          headers: {
            "auth-token": userToken,
          },
        }
      )
      .then((res) => {
        const result = res.data;
        if (result.success) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Category updated successfully.",
            showConfirmButton: false,
            timer: 1500,
          });
          e.target.reset();
          props.history.push("/blogs/blogcategory");
        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: result.message,
            showConfirmButton: false,
            timer: 1500,
          });
        }
        console.log("result >> ", result);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getCategoryDetails();
  }, [id]);
  return (
    <MainContainer>
      {isLoading && <Loader />}
      <div className="card">
        <div className={"card-header"}>
          <div className="row">
            <div className="col-sm-6">
              <h4>Edit Blog Category</h4>
            </div>
          </div>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="form-group">
              <label>Category Name</label>
              <input
                type="text"
                className="form-control"
                placeholder={"Category Name"}
                name="category"
                ref={register({ required: true })}
              />
              {errors.category && (
                <span className="isError">Category is required.</span>
              )}
            </div>
            <div className={"d-flex"}>
              <button
                type="submit"
                className="btn btn-success"
                style={{ marginRight: 15 }}
              >
                Save changes
              </button>
              <button
                type={"button"}
                className="btn btn-primary"
                onClick={() => history.goBack()}
              >
                Go Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </MainContainer>
  );
};
const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
export default connect(mapStateToProps)(EditBlogCategory);
